<template>
    <div>
        <div class="d-flex">
            <div class="mr-auto">
                <button class="btn btn-secondary" @click="refresh"><i class="fas fa-sync-alt"></i></button>
                <slot name="buttons"></slot>
            </div>
            <div class="align-self-end">
                <input-debounced
                    v-model="search"
                    :clearable="true"
                    :autofocus="true"
                    placeholder="Search"
                    class="search-bar w-300 mb-2"
                ></input-debounced>
            </div>
        </div>
        <base-table
            :base-url="urlWithFilters"
            ref="baseTable"
            @load-success="onLoadSuccess"
            @refresh="onRefresh"
            :current-page="currentPage"
            v-loading="isRefreshing"
            element-loading-spinner="el-icon-loading"
        >
            <template v-slot>
                <el-table
                    :data="items"
                    stripe
                    style="width: 100%">
                    <el-table-column
                        prop="model.id"
                        label="Id"
                        width="70"
                    ></el-table-column>
                    <el-table-column
                        prop="model.type_text"
                        label="Type"
                        width="170"
                    ></el-table-column>
                    <el-table-column
                        prop="model.name"
                        label="Name"
                        width="240"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="model.status_text"
                        label="Status"
                        width="85"
                        align="center"
                        v-slot="{row: {model: {status, status_text}}}"
                    >
                        <status-column :value="status" :text="status_text"></status-column>
                    </el-table-column>
                    <el-table-column
                        prop="model.input_file"
                        label="Input File"
                        min-width="300"
                    ></el-table-column>
                    <el-table-column
                        prop="model.report"
                        label="Report"
                        width="80"
                    >
                        <template v-slot="{row}">
                            <el-button
                                :disabled="!isReportAvailable(row)"
                                @click="showDetails(row)"
                                type="text"
                                size="small"
                            >Details</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="model.log_file"
                        label="Import Log"
                        width="160"
                        v-slot="{row: {model: {log_file}, logFileUrl}}"
                    >
                        <a v-if="logFileUrl" :href="logFileUrl">{{ log_file }}</a>
                    </el-table-column>
                    <el-table-column
                        prop="model.user.full_name"
                        label="User"
                        width="120"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="model.created_at"
                        :formatter="formatDate"
                        label="Created"
                        width="130"
                    ></el-table-column>
                  <el-table-column
                      label="Actions"
                      v-slot="{row}"
                      width="120"
                  >
                    <actions-column :row="row" @revert="onRevert"></actions-column>
                  </el-table-column>
                </el-table>
            </template>
        </base-table>
        <el-pagination
            layout="prev, pager, next"
            :total="total"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            class="text-right"
        ></el-pagination>
        <report-viewer ref="reportViewer"></report-viewer>
    </div>
</template>

<script>
  import TableWithPagination from '../table-with-pagination';
  import {addQueryParams} from '../../libs/url';
  import ReportViewer from '../../components/import/report';
  import StatusColumn from './status-column';
  import ActionsColumn from './actions-column';
  import {isFilled} from "../../helpers";

  export default {
    extends: TableWithPagination,
    components: {
      ReportViewer,
      StatusColumn,
      ActionsColumn,
    },

    data() {
      return {
        search: null,
        filters: {},
      };
    },

    computed: {
      /**
       * @return {string}
       */
      urlWithFilters() {
        return addQueryParams(this.url, this.filters);
      },
    },

    watch: {
      search(value) {
        if (value) {
          this.filters = _.assign({}, this.filters, {search: value});
        } else {
          this.filters = _.omit(this.filters, ['search']);
        }
      },
    },

    methods: {
      /**
       * @param {Object} row
       * @param {Object} col
       * @param {string} datetime
       */
      formatDate(row, col, {datetime}) {
        return moment(datetime).format(config('format.moment.short.datetime'));
      },

      /**
       * @return {undefined}
       */
      refresh() {
        this.$refs.baseTable.refresh();
      },

      /**
       * @return {boolean}
       */
      isReportAvailable({model: {report}}) {
        return isFilled(report);
      },

      /**
       * @return {undefined}
       */
      showDetails(row) {
        this.$refs.reportViewer.show(row);
      },

      /**
       * @param {Object} row
       * @param {string} url
       */
      onRevert({row, url}) {
        this.isRefreshing = true;
        axios.post(url)
            .then(({data: {message}}) => {
              _.isString(message) && this.$message.success(message);
              this.refresh();
            })
            .catch(err => {
              this.handleErrorResponse(err);
              this.refresh();
            });
      },
    },
  }
</script>
